export const DEFAULT_LOCALE = 'en';

export const SLICE_NAME = 'language';
